import { useState } from "react";
import Icon from "../../../Icons/general/Icon";
import PropTypes from 'prop-types';
import Modal from "..";

function SpinnerPModal({ show, handleshow, handleAreas }) {
    
  const handleAceptar = (e) => {
    handleshow(false);
    handleAreas();
  };
  return (
    <>
     <Modal isOpen={show} onClose={()=>handleshow(false)} title={'Bienvenidos'}>
       <div className="flex flex-col lg:w-[24rem]">
          <div className="w-full flex flex-row  items-center justify-center">
            <div className="flex flex-2">
              <Icon svg="volumeSlash" className="w-[6rem] h-[6rem] fill-gray-600" title="volumeSlash" />
            </div>  
              <span className="text-sm lg:text-[0.97rem] text-justify text-gray-800 flex-1 mx-4">Por politicas de los navegadores, la reproducción automática de sonidos y videos está prohibido, ésta pantalla reproduce audios y videos, el navegador requiere confirmación de que estas de acuerdo dando click en el botón "Aceptar"</span>
          </div>
          <div className="flex w-full mt-1 justify-end">
             <button name="Aceptar" className="btnprimary" onClick={handleAceptar}  type="button">Aceptar</button>
          </div>
        </div>  
     </Modal>
    </>
  );
}
SpinnerPModal.propTypes = {
  show: PropTypes.bool.isRequired,
  handleAreas: PropTypes.func.isRequired,
  handleshow: PropTypes.func.isRequired,
  
  
};

export default SpinnerPModal;
